import {Injectable} from '@angular/core';
import {FormDefinitionFieldModel} from '../../api/entity/formDefinitionField.model';
import {Order, Sort, UrlParameter} from '../../../../../../shared/utils/url.builder';
import {CachedtFindAllService} from '../../../../../core/service/v2/service/findAll/cachedtFindAll.service';
import {FormDefinitionFieldFindAllService} from './formDefinitionFieldFindAll.service';
import {FormDefinitionFieldSummaryModel} from "../../api/entity/formDefinitionFieldSummary.model";
import {FormDefinitionFieldSummaryFindAllService} from "./formDefinitionFieldSummaryFindAll.service";

@Injectable({
    providedIn: "root"
})
export class FormDefinitionFieldFindAllCachedService
    extends CachedtFindAllService<FormDefinitionFieldModel, FormDefinitionFieldSummaryModel> {

    constructor(service: FormDefinitionFieldSummaryFindAllService) {
        super(service, [], new Sort('label', Order.ASCENDING));
    }

}
